// AdAura Awards 2026 - Content data

export const PILLARS = [
  {
    id: 'aura-supremes',
    number: '01',
    name: 'Aura Supremes',
    tagline: 'The marquee honours of the night - the highest distinction across the entire awards.',
    categories: [
      { name: 'Brand of the Year', desc: 'Recognises a brand that demonstrates exceptional marketing excellence, consumer relevance and business impact throughout the eligibility period.' },
      { name: 'Campaign of the Year', desc: 'Honours a campaign that stands out for its strategic thinking, creative execution and measurable impact on both the brand and its audience.' },
      { name: 'Creative Agency of the Year', desc: 'Recognises a creative agency that consistently delivered impactful and innovative work across campaigns, brands and platforms.' },
      { name: 'Media Agency of the Year', desc: 'Recognises a media agency that demonstrates excellence in planning, strategy, innovation and media effectiveness.' },
      { name: 'Independent Agency of the Year', desc: 'Honours an independent agency that delivers outstanding work while demonstrating creativity, effectiveness and business growth.' },
      { name: 'Emerging Brand of the Year', desc: 'Recognises a young or rapidly growing brand that successfully built visibility, relevance and market impact within a short span of time.' },
    ],
  },
  {
    id: 'integrated-marketing-excellence',
    number: '02',
    name: 'Integrated Marketing Excellence',
    tagline: 'Big-canvas work where strategy and creativity move in unison across every touchpoint.',
    categories: [
      { name: 'Integrated Marketing Campaign of the Year', desc: 'Recognises campaigns that seamlessly combine multiple channels and touchpoints to deliver a unified brand experience and measurable results.' },
      { name: 'Product Launch Campaign of the Year', desc: 'Honours campaigns that successfully introduced a new product or service through strategic planning, impactful execution and strong market response.' },
      { name: 'Commerce Marketing Campaign of the Year', desc: 'Recognises campaigns designed to drive commerce outcomes through retail, marketplace or direct-to-consumer channels. The focus is on influencing purchase decisions, conversion and measurable business impact.' },
      { name: 'Consumer Engagement Campaign of the Year', desc: 'Recognises campaigns that encourage meaningful audience participation and strengthened consumer relationships through engaging experiences.' },
      { name: 'Brand Collaboration Campaign of the Year', desc: 'Celebrates collaborations between two or more brands that created greater cultural relevance, audience engagement or business impact together.' },
      { name: 'Omnichannel Campaign of the Year', desc: 'Recognises campaigns that deliver a consistent and connected experience across online, offline and emerging consumer touchpoints.' },
    ],
  },
  {
    id: 'social-content-excellence',
    number: '03',
    name: 'Social & Content Excellence',
    tagline: 'Stories built natively for feeds, conversations and communities.',
    categories: [
      { name: 'Social Media Campaign of the Year', desc: 'Recognises campaigns that effectively leverage social platforms to drive engagement, conversations and brand impact.' },
      { name: 'Meme Marketing Campaign of the Year', desc: 'Celebrates campaigns that successfully used meme culture to connect with audiences through relevance, humour and shareability.' },
      { name: 'Short-Form Video Campaign of the Year', desc: 'Recognises campaigns built around short-form video formats that capture attention, drive engagement and deliver measurable results.' },
      { name: 'Long-Form Video Campaign of the Year', desc: 'Recognises campaigns that use long-format video content to deliver compelling storytelling and meaningful audience engagement. The focus is on sustained viewer attention, narrative strength and overall brand impact.' },
      { name: 'Branded Content Campaign of the Year', desc: 'Honours content-led initiatives that integrate brands naturally into compelling narratives, formats or content ecosystems.' },
      { name: 'Social Engagement Campaign of the Year', desc: 'Celebrates campaigns that build active audience participation, conversations and community engagement across social platforms.' },
    ],
  },
  {
    id: 'creative-excellence',
    number: '04',
    name: 'Creative Excellence',
    tagline: 'The craft of the idea - storytelling, experience and the rare ones that move culture.',
    categories: [
      { name: 'Storytelling Campaign of the Year', desc: 'Recognises campaigns that use powerful storytelling to build emotional connections and strengthen brand recall.' },
      { name: 'Experiential Marketing Campaign of the Year', desc: 'Recognises immersive brand experiences that enable meaningful consumer interaction beyond traditional advertising.' },
      { name: 'Multilingual Campaign of the Year', desc: 'Celebrates campaigns that effectively adapt messaging across multiple languages while maintaining consistency and relevance.' },
      { name: 'Cultural Impact Campaign of the Year', desc: 'Recognises campaigns that sparked conversations, influenced cultural narratives or became part of the broader public discourse.' },
      { name: 'Creative Breakthrough Campaign of the Year', desc: 'Honours work that challenged conventions and introduced a fresh creative approach to solving a marketing challenge.' },
    ],
  },
  {
    id: 'influencer-marketing-excellence',
    number: '05',
    name: 'Influencer Marketing Excellence',
    tagline: 'Creator-led work where strategy and storytelling outperform the spend.',
    categories: [
      { name: 'Influencer Marketing Campaign of the Year', desc: 'Recognises campaigns that effectively leveraged influencers to drive awareness, engagement and brand impact.' },
      { name: 'Creator Collaboration Campaign of the Year', desc: 'Celebrates meaningful collaborations between brands and content creators that resulted in authentic and impactful storytelling.' },
      { name: 'Celebrity Partnership Campaign of the Year', desc: 'Recognises campaigns that strategically partnered with celebrities to strengthen brand relevance and audience connection.' },
      { name: 'Regional Influencer Campaign of the Year', desc: 'Honours campaigns that leveraged regional creators to build strong connections with local or vernacular audiences.' },
      { name: 'Influencer-Led Product Launch of the Year', desc: 'Recognises product launches where influencers played a central role in driving awareness, engagement and adoption.' },
    ],
  },
  {
    id: 'ai-innovation-excellence',
    number: '06',
    name: 'AI & Innovation Excellence',
    tagline: 'Where new technology delivered a sharper idea - not just a shinier one.',
    categories: [
      { name: 'AI-Powered Marketing Campaign of the Year', desc: 'Recognises campaigns that leverage artificial intelligence to enhance creativity, personalisation, efficiency or consumer engagement.' },
      { name: 'Generative AI Campaign of the Year', desc: 'Honours campaigns that creatively use generative AI tools to develop content, experiences or marketing assets at scale.' },
      { name: 'AI-Driven Consumer Experience of the Year', desc: 'Recognises initiatives that use AI to create more intuitive, personalised or engaging consumer experiences.' },
      { name: 'Marketing Innovation of the Year', desc: 'Celebrates breakthrough marketing ideas, approaches or solutions that redefined how brands connect with consumers.' },
      { name: 'Emerging Technology Campaign of the Year', desc: 'Recognises campaigns that effectively leveraged emerging technologies to create distinctive brand experiences and impact.' },
      { name: 'Data-Driven Marketing Campaign of the Year', desc: 'Honours campaigns where audience insights, analytics and data intelligence played a central role in strategy and execution.' },
      { name: 'CGI & Mixed Reality Campaign of the Year', desc: 'Recognises campaigns that used CGI, mixed reality or immersive technologies to create compelling visual storytelling and engagement.' },
    ],
  },
  {
    id: 'sports-marketing-excellence',
    number: '07',
    name: 'Sports Marketing Excellence',
    tagline: 'Brand work built around fans, athletes and the unscripted moments of sport.',
    categories: [
      { name: 'Sports Marketing Campaign of the Year', desc: 'Recognises campaigns that successfully leveraged sporting properties, athletes, events or fan communities to drive brand impact.' },
    ],
  },
  {
    id: 'festive-seasonal-marketing-excellence',
    number: '08',
    name: 'Festive & Seasonal Marketing Excellence',
    tagline: 'Brand storytelling tied to the moments India is already paying attention to.',
    categories: [
      { name: 'Festive Marketing Campaign of the Year', desc: 'Recognises campaigns built around festive occasions that successfully connected with audiences through relevance, emotion and impact.' },
      { name: 'Regional Festival Campaign of the Year', desc: 'Honours campaigns created around regional festivals that demonstrated strong cultural understanding and audience resonance.' },
      { name: 'Seasonal Marketing Campaign of the Year', desc: 'Recognises campaigns that effectively leverage seasonal moments, trends or consumer behaviours to achieve marketing objectives.' },
      { name: 'Festive Retail Activation of the Year', desc: 'Celebrates retail-led festive initiatives that enhanced consumer engagement and drove meaningful business outcomes.' },
      { name: 'Moment Marketing Campaign of the Year', desc: 'Recognises campaigns that capitalise on cultural, social or topical moments to create timely relevance and audience engagement.' },
    ],
  },
  {
    id: 'media-excellence',
    number: '09',
    name: 'Media Excellence',
    tagline: 'The strategy, planning and buying that put the idea exactly where it needed to be.',
    categories: [
      { name: 'Print Campaign of the Year', desc: 'Recognises campaigns that use print media creatively and effectively to communicate a compelling brand message.' },
      { name: 'Out-of-Home Campaign of the Year', desc: 'Honours campaigns that leverage outdoor media to create high visibility, audience engagement and brand impact.' },
      { name: 'Television Campaign of the Year', desc: 'Recognises campaigns that effectively use television as a medium to drive reach, storytelling and consumer influence.' },
      { name: 'Audio Campaign of the Year', desc: 'Celebrates campaigns that leverage radio, podcasts or audio-first formats to create memorable audience experiences.' },
      { name: 'OTT Campaign of the Year', desc: 'Recognises campaigns that effectively utilise streaming platforms to engage audiences through innovative content or advertising.' },
      { name: 'Cinema Advertising Campaign of the Year', desc: 'Honours campaigns that leverage the cinema environment to create impactful and immersive brand experiences.' },
      { name: 'Retail Media Campaign of the Year', desc: 'Recognises campaigns that effectively use retail media networks and commerce platforms to influence consumer decisions and drive results.' },
    ],
  },
  {
    id: 'purpose-impact-excellence',
    number: '10',
    name: 'Purpose & Impact Excellence',
    tagline: 'Brand work in service of people, communities and the planet - backed by real outcomes.',
    categories: [
      { name: 'Purpose-Led Campaign of the Year', desc: 'Recognises campaigns driven by a larger social, cultural or community purpose while maintaining strong brand relevance.' },
      { name: 'Sustainability Campaign of the Year', desc: 'Honours initiatives that promote environmental responsibility, sustainable practices or positive behavioural change.' },
      { name: 'CSR Campaign of the Year', desc: 'Recognises corporate social responsibility initiatives that create meaningful and measurable impact for communities or causes.' },
      { name: 'Public Awareness Campaign of the Year', desc: 'Celebrates campaigns that successfully raise awareness, educate audiences or inspire action around important societal issues.' },
    ],
  },
];

export const ENTRANTS = [
  'Brands & Marketing Teams',
  'Creative Agencies',
  'Media Agencies',
  'Digital Marketing Agencies',
  'Influencer Marketing Agencies',
  'Production Houses & Content Studios',
  'PR & Communications Agencies',
  'Sports Marketing Agencies',
  'Creator-Led Agencies',
  'Independent Creators',
  'Startups & Emerging Businesses',
  'Martech & Adtech Companies',
  'In-House Creative Teams',
  'Publishers & Media Networks',
];

export const WHY_ENTER = [
  {
    n: '01',
    title: 'A Mark Of True Distinction',
    body: 'AdAura is the recognition the industry is already paying attention to - judged by the people whose opinion matters.',
  },
  {
    n: '02',
    title: 'A Stage For The Work That Matters',
    body: 'A platform built for the rare ideas - the ones that move culture, business and the people behind them.',
  },
  {
    n: '03',
    title: 'A Room You Want To Be In',
    body: 'A night with 300+ industry leaders, marketers and creators - the most consequential rooms of the year.',
  },
];

export const JUDGING_CRITERIA = [
  { roman: 'I', name: 'Strategic Excellence', desc: 'How effectively did the work address a business objective, audience insight or market challenge?' },
  { roman: 'II', name: 'Creative Distinction', desc: 'Did the campaign stand out through originality, storytelling, innovation or creative execution?' },
  { roman: 'III', name: 'Execution Excellence', desc: 'How effectively was the idea brought to life across channels, formats and consumer touchpoints?' },
  { roman: 'IV', name: 'Audience Impact', desc: 'Did the work drive engagement, participation, conversation or cultural relevance among its intended audience?' },
  { roman: 'V', name: 'Business Impact', desc: 'What measurable outcomes did the campaign deliver in terms of brand growth, awareness, engagement, consideration or commercial success?' },
  { roman: 'VI', name: 'Innovation', desc: 'Where relevant, how effectively did the work leverage emerging technologies, platforms or unconventional approaches to create impact?' },
];

export const ELIGIBILITY = [
  {
    k: 'A',
    title: '',
    body: 'While there is no restriction on the nationality of the applicant, entries must come from individuals or teams who are actively involved in India\u2019s advertising, marketing, media, or entertainment ecosystem. To be eligible, the submitted work must be at least 50% executed or completed between July 1, 2025 and Till Date.',
  },
  {
    k: 'B',
    title: '',
    body: 'Applicants are solely responsible for providing accurate information through the official entry form available on the website. Reference materials must follow the prescribed format and should be submitted as high-resolution digital images, creatives, or videos - as specified.',
  },
  {
    k: 'C',
    title: '',
    body: 'The nomination form includes mandatory fields that must be filled before the final submission deadline. Once submitted, entries cannot be edited. Any form with incomplete information, multiple submissions for the same project, or missing payment proof will be disqualified from the evaluation process.',
  },
  {
    k: 'D',
    title: '',
    body: 'Entries involving misrepresentation or fraudulent content will be immediately disqualified, and the nomination fee will not be refunded. Any discrepancy found in the provided links, decks, or case studies will result in the entry being excluded from jury consideration.',
  },
  {
    k: 'E',
    title: '',
    body: 'All evaluation-related decisions - including eligibility, category reassignment, or judgment - will be at the sole discretion of The AdAURA Awards Jury Panel. These decisions are final and binding, and Marketing Mind shall not entertain any appeals or objections post-declaration.',
  },
  {
    k: 'F',
    title: '',
    body: 'In instances where a project is a collaboration between multiple entities (such as brand and agency, or multiple agencies), it is the responsibility of the submitting party to ensure all involved stakeholders are acknowledged and have consented to the entry.',
  },
];

export const TERMS = [
  { k: '1', body: 'Agencies applying on behalf of a brand must provide an approval letter or screenshot of similar correspondence from the brand. The letter must clearly state the Event Name, Campaign Name, Category Name, and the client\u2019s email. If the brand is applying directly, they must submit their logo in the approval section.' },
  { k: '2', body: 'Entrants must ensure that their entries are viewable across multiple browsers and platforms. Marketing Mind will not contact entrants if an entry is inaccessible and holds the right to disqualify and exclude the same from the final judging process.' },
  { k: '3', body: 'Participants receiving an award in any category must have applied as an independent entity. And shortlisting of entries does not guarantee that an applicant will become the final winner.' },
  { k: '4', body: 'Once the final entry is submitted and the final payment is made, the same will be non-refundable. Also, the Jury solely reserves the right to cancel any category if no participant is deemed worthy of inclusion.' },
  { k: '5', body: 'During the judging process, Marketing Mind or any of its representatives may contact clients associated with any entry upon the jury\u2019s request.' },
  { k: '6', body: 'All submitted entries for The AdAura Awards 2026 will become the property of Marketing Mind and may be used for promotional or reporting purposes.' },
  { k: '7', body: 'Marketing Mind retains the right to modify the content of its website without prior notice. Applicants are advised to regularly check for updates.' },
  { k: '8', body: 'Marketing Mind reserves the right to amend, withdraw, or add to the Terms and Conditions at its discretion, with prospective or retrospective effect.' },
  { k: '9', body: 'All disputes arising out of or related to The AdAURA Awards 2026 will be governed by the laws of India and will be subjected to the exclusive jurisdiction of the courts in Gautam Budh Nagar, Uttar Pradesh.' },
];

export const STATS = [
  { value: '10', label: 'Award Pillars' },
  { value: '50+', label: 'Categories' },
  { value: '300+', label: 'Industry Leaders' },
  { value: '01', label: 'Unparalleled Night' },
];

export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/categories', label: 'Categories' },
  { to: '/judging', label: 'Judging' },
  { to: '/jury', label: 'Jury' },
  { to: '/eligibility', label: 'Eligibility' },
  { to: '/winners', label: 'Winners' },
  { to: '/gallery', label: 'Photo Gallery' },
  { to: '/contact', label: 'Contact' },
];

export const KEY_DATES = [
  // Public site now surfaces the full announced timeline. Order top-to-bottom
  // mirrors the entrant journey: nominations → judging → ceremony night.
  { label: 'Nominations Close', date: '6 September 2026', state: 'open' },
  { label: 'Jury Evaluation',   date: '15–30 September 2026', state: 'upcoming' },
  { label: 'Awards Night',      date: '8 October 2026', venue: 'Aerocity, New Delhi', state: 'final' },
];

export const WHY_ENTER_DETAILED = [
  { n: '01', t: 'Credibility', d: 'Get recognised by a respected jury and platform rooted in authenticity, integrity and real-world excellence.' },
  { n: '02', t: 'Team Glory', d: 'Honour the mentors, crew, dreamers and executors behind the brilliance.' },
  { n: '03', t: 'Visibility', d: 'Let your work shine across our powerful industry ecosystem.' },
  { n: '04', t: 'Creativity Meets Strategy', d: 'Be celebrated not just for what you made, but for why it mattered.' },
  { n: '05', t: 'Recognition That Resonates', d: 'From boardrooms to brainstorms, this win means something.' },
];

export const KEY_HIGHLIGHTS = [
  { n: '10', t: 'Award Pillars Across Marketing Excellence' },
  { n: '50+', t: 'Curated Award Categories' },
  { n: '300+', t: 'Industry Leaders & Decision-Makers' },
  { n: '', icon: 'Handshake', t: 'Unparalleled Networking Opportunities' },
  { n: '', icon: 'Crown', t: 'Presence Of Leading CMOs, CEOs, Founders & Agency Leaders' },
];

export const ENTRANTS_DETAILED = [
  'Brands & Marketing Teams',
  'Creative Agencies',
  'Media Agencies',
  'Digital Marketing Agencies',
  'Influencer Marketing Agencies',
  'Production Houses & Content Studios',
  'Public Relations & Communications Agencies',
  'Sports Marketing Agencies',
  'Creator-Led Agencies & Talent Networks',
  'Independent Creators Working With Brands',
  'Startups & Emerging Businesses',
  'Martech & Adtech Companies',
  'In-House Creative Teams',
  'Publishers & Media Networks',
];

export const ENTRANTS_DESCRIBED = [
  { t: 'Brands & Marketing Teams', d: 'In-house brand custodians and marketing departments responsible for strategy, campaign development and brand stewardship.' },
  { t: 'Creative Agencies', d: 'Full-service or specialist agencies behind the big idea — concept, craft, design and creative direction.' },
  { t: 'Media Agencies', d: 'Planning and buying houses driving smart, measurable media decisions across traditional and digital surfaces.' },
  { t: 'Digital Marketing Agencies', d: 'Performance, programmatic, SEO, content and social specialists shaping the always-on side of brand growth.' },
  { t: 'Influencer Marketing Agencies', d: 'Teams curating talent partnerships, creator-led storytelling and authentic, audience-first advocacy.' },
  { t: 'Production Houses & Content Studios', d: 'Studios that bring scripts to life — film, photography, animation, sound and post-production.' },
  { t: 'Public Relations & Communications Agencies', d: 'PR firms shaping brand narrative through earned media, reputation, crisis response and corporate storytelling.' },
  { t: 'Sports Marketing Agencies', d: 'Specialists in sports IP — athlete partnerships, fan engagement, sponsorships and on-ground activations.' },
  { t: 'Creator-Led Agencies & Talent Networks', d: 'Agencies built around creator economies — managing talent, content rights and brand collaborations at scale.' },
  { t: 'Independent Creators Working With Brands', d: 'Solo creators and small studios producing original work for and with brands across every platform.' },
  { t: 'Startups & Emerging Businesses', d: 'Early-stage and growth-stage companies pushing fresh categories, lean budgets and outsized ambition.' },
  { t: 'Martech & Adtech Companies', d: 'Technology platforms powering measurement, automation, personalisation and the modern marketing stack.' },
  { t: 'In-House Creative Teams', d: 'Brand-side creative units producing work that traditionally agencies would deliver — but with deeper context.' },
  { t: 'Publishers & Media Networks', d: 'Editorial and broadcast platforms doing distinguished branded content, native storytelling and audience work.' },
];

export const PROCESS_STEPS = [
  { step: 'Step 01', title: 'Scrutiny By Tabulator', body: 'An expert tabulator independently verifies every entry for eligibility, category fit and the integrity of every claim made.' },
  { step: 'Step 02', title: 'Two-Tier Jury Review', body: 'A two-stage judging process by the country\u2019s top professionals shortlists the strongest five entries in every category.' },
  { step: 'Step 03', title: 'The Grand Jury', body: 'A grand jury - chaired by senior industry voices - selects the eventual winners from the final shortlist for each category.' },
];

export const HIGHLIGHT_CARDS = [
  { t: 'Entry Fees', d: 'Tiered pricing across Early Bird, Regular and Late deadlines - built for independents and networks alike.' },
  { t: 'Entry Guidelines', d: 'Everything you need to know: case templates, supporting material specs, and category-specific requirements.' },
  { t: 'The AdAura Trophy', d: 'A sculpted brass-and-velvet trophy - designed in India, made to sit on a desk for years, not weeks.' },
  { t: 'Top 1% Club', d: 'Every winner joins the AdAura Top 1% - a curated network of the year\u2019s most decorated marketers and creators.' },
];

export const FAQS = [
  { q: 'Who can enter the AdAura Awards 2026?', a: 'Entries are open to brands, agencies, networks, independents, creators, startups, publishers and in-house teams actively involved in India\u2019s advertising, marketing, media or entertainment ecosystem. To be eligible, the submitted work must be at least 50% executed or completed between July 1, 2025 and Till Date.' },
  { q: 'Can a single piece of work be entered into more than one category?', a: 'Yes. A single piece may be entered into multiple categories. The nomination form also allows you to select up to two additional categories for the same entry, in addition to the primary one.' },
  { q: 'What is the entry fee?', a: 'The nomination fee is ₹7,500 + 18% GST per entry. This applies uniformly to every category. Payment is collected securely at the time of submission through our official payment gateway.' },
  { q: 'How is judging done?', a: 'Entries are evaluated by an independent jury across six criteria - Strategic Excellence, Creative Distinction, Execution Excellence, Audience Impact, Business Impact and Innovation. Work is rewarded only when craft and outcome travel together.' },
  { q: 'Will sensitive performance data be kept confidential?', a: 'Yes. Performance numbers can be marked confidential in the nomination form and are shared only with the jury under NDA. Only the approved case summary and credits are made public for winners.' },
  { q: 'When and where will the awards night be held?', a: 'The AdAura Awards 2026 night will be held on 8 October 2026 at Aerocity, New Delhi. Further details will be communicated to all shortlisted entries and partners closer to the date.' },
  { q: 'How can my brand partner with AdAura?', a: 'Sponsorship and partnership opportunities are open across Title, Presenting, Category and Knowledge tiers. Reach out via the Contact page or write to us at atuldwivedi@marketingmind.in.' },
];

export const SPONSOR_TIERS = [
  { tier: 'Title Partner', slots: 1 },
  { tier: 'Presenting Partner', slots: 1 },
  { tier: 'Powered By', slots: 2 },
  { tier: 'Category Partners', slots: 4 },
  { tier: 'Knowledge Partners', slots: 3 },
];

export const NEWS_HIGHLIGHTS = [
  { tag: 'Announcement', title: 'AdAura Awards 2026: Nominations Now Open', date: '15 Dec 2025', excerpt: 'Marketing Mind opens nominations for India\u2019s most consequential marketing awards night - built for the rare work that left a mark.' },
  { tag: 'Jury', title: 'The First Names On The AdAura Jury 2026', date: '08 Dec 2025', excerpt: 'A first look at the senior CMOs, agency principals and founders confirmed to chair the AdAura jury chambers this year.' },
  { tag: 'Editorial', title: 'What Earns A Win At AdAura - Strategy + Outcome', date: '02 Dec 2025', excerpt: 'A look at why AdAura rewards strategy and business outcome alongside creative craft - and how that should shape your case.' },
];

export const CONTACTS = [
  {
    for: 'Nominations & Sponsorship',
    name: 'Atul Dwivedi',
    phone: '+91 97170 25198',
    email: 'atuldwivedi@marketingmind.in',
  },
  {
    for: 'Speakership, Jury & Other Queries',
    name: 'AdAura Awards Desk',
    phone: '+91 97170 25198',
    email: 'awards@marketingmind.co',
  },
];

export const OFFICES = [
  {
    label: 'Marketing Mind Office',
    city: 'Noida',
    address: 'F-40, Second Floor, Sector 6, Noida, Uttar Pradesh, 201301',
  },
];
